import { userService } from "../../services/userService";

export function setFilter(filter) {
  return (dispatch) => {
    dispatch({ type: "SET_FILTER", filter });
  };
}

export function clearFilter() {
  return (dispatch) => {
    dispatch({ type: "CLEAR_FILTER" });
  };
}

export function setEditUser(userIdxEdited) {
  return async (dispatch) => {
    dispatch({ type: "SET_USERIDXEDITED", userIdxEdited });
  };
}

export function loadUsers(filterBy) {
  return async (dispatch) => {
    const users = await userService.query(filterBy);
    dispatch({ type: "SET_USERS", users });
  };
}
export function loadAdmin() {
  return async (dispatch) => {
    const users = await userService.getAdmin();
    dispatch({ type: "SET_USERS", users });
  };
}
export function removeUser(userId) {
  return async (dispatch) => {
    await userService.remove(userId);
    dispatch({ type: "REMOVE_USER", userId });
  };
}

export function saveUser(user) {
  return async (dispatch) => {
    const actionType = user._id ? "UPDATE_USER" : "ADD_USER";
    user = await userService.save(user);
    dispatch({ type: actionType, user });
  };
}

export function login(userCreds) {
  return async (dispatch) => {
    const user = await userService.login(userCreds);
    // console.log(user);
    dispatch({ type: "SET_USER", user });
    // window.location.assign("/#/");
  };
}
export function sendPassword(userCreds) {
  return async (dispatch) => {
    // console.log("totooo");

    const user = await userService.sendPassword(userCreds);
    // console.log(user);
    // dispatch({ type: "SET_USER", user });
    // window.location.assign("/#/");
  };
}
export async function sendEmail(msg) {
  // console.log("totooo");

  // return async (dispatch) => {
  // console.log(msg);

  const user = await userService.sendEmail(msg);
  //console.log("user", user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // };
}
export function sendCheckMail(userCreds) {
  return async (dispatch) => {
    // console.log("totooo");
    const user = await userService.sendCheckMail(userCreds);
    // console.log(user);
    // dispatch({ type: "SET_USER", user });
    // window.location.assign("/#/");
    return user;
  };
}
export async function keepParasha2() {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.keepParasha();
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data;
  //};
}
export async function keepParasha23() {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.keepParashaH();
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data;
  //};
}
export async function keepKiddush2() {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.keepKiddush();
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data;
  //};
}
export async function keepShlishit2() {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.keepShlishit();
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data;
  //};
}
export async function keepName(userCreds) {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.getById(userCreds);
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data.firstName + " " + data.lastName;
  //};
}
export async function keepMaftir2() {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.keepMaftir();
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data;
  //};
}
export async function keepMaftir23() {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.keepMaftirH();
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data;
  //};
}
export async function keepInfHome() {
  //return async (dispatch) => {
  // console.log("totooo");
  const data = await userService.keepInfHome();
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);
  return data;
  //};
}
export async function sendParasha2(data) {
  return await userService.sendParasha(data);
}
export async function updateParasha2(data) {
  return await userService.updateParasha(data);
}

export async function removeParasha2(parashaId) {
  return await userService.removeParasha(parashaId);
}
export async function sendMaftir2(data) {
  //return async (dispatch) => {
  // console.log("totooo");
  return await userService.sendMaftir(data);
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
  // console.log("data useraction", data);

  //};
}
export async function sendParasha23(data) {
  return await userService.sendParashaH(data);
}
export async function updateParasha23(data) {
  return await userService.updateParashaH(data);
}

export async function removeParasha23(parashaHId) {
  return await userService.removeParashaH(parashaHId);
}
export async function sendMaftir23(data) {
  return await userService.sendMaftirH(data);
}
export async function updateMaftir23(data) {
  return await userService.updateMaftirH(data);
}

export async function removeMaftir23(maftirHId) {
  return await userService.removeMaftirH(maftirHId);
}
export async function updateMaftir2(data) {
  return await userService.updateMaftir(data);
}

export async function removeMaftir2(maftirId) {
  return await userService.removeMaftir(maftirId);
}
export async function sendShlishit2(data) {
  return await userService.sendShlishit(data);
}

export async function updateShlishit2(data) {
  return await userService.updateShlishit(data);
}

export async function removeShlishit2(shlishitId) {
  return await userService.removeShlishit(shlishitId);
}
export async function sendKiddush2(data) {
  return await userService.sendKiddush(data);
}
export async function updateKiddush2(data) {
  return await userService.updateKiddush(data);
}

export async function removeKiddush2(kiddushId) {
  return await userService.removeKiddush(kiddushId);
}
export async function keepEvennement2() {
  const data = await userService.keepEvennement();
  return data;
}

export async function sendEvennement2(data) {
  return await userService.sendEvennement(data);
}

export async function updateEvennement2(data) {
  return await userService.updateEvennement(data);
}

export async function removeEvennement2(evennementId) {
  return await userService.removeEvennement(evennementId);
}
export async function keepDecaissement2(filterBy = {}) {
  const data = await userService.keepDecaissement(filterBy);
  return data;
}

export async function sendDecaissement2(data) {
  return await userService.sendDecaissement(data);
}

export async function updateDecaissement2(data) {
  return await userService.updateDecaissement(data);
}

export async function removeDecaissement2(decaissementId) {
  return await userService.removeDecaissement(decaissementId);
}
export function newPassword(userCreds) {
  return async (dispatch) => {
    const rep = await userService.changePassword(userCreds);
    //console.log("reppp", rep);
  };
  // console.log(user);
  // dispatch({ type: "SET_USER", user });
  // window.location.assign("/#/");
}

/*export const login = (userCreds) => {
  return async (dispatch) => {
    return {
     user = await userService.login(userCreds),
    dispatch({ type: "SET_USER", user });
    // window.location.assign("/#/");
  };}
};*/

export function signup(userCreds) {
  return async (dispatch) => {
    const user = await userService.signup(userCreds);
    dispatch({ type: "SET_USER", user });
  };
}

export function logout() {
  return async (dispatch) => {
    await userService.logout();
    dispatch({ type: "SET_USER", user: null });
    dispatch({ type: "SET_CRMS", crms: [] });
    dispatch({ type: "SET_USERS", users: [] });
    dispatch({ type: "SET_CRMSSCRED", crmsSoldCred: null });
    dispatch({ type: "SET_CRMSSDEB", crmsSoldDeb: null });
    dispatch({ type: "SET_CRMIDXEDITED", crmIdxEdited: null });
    dispatch({ type: "SET_USERIDXEDITED", userIdxEdited: null });
    dispatch({ type: "SET_CRMSCRED", crmUSoldCred: null });
    dispatch({ type: "SET_CRMSDEB", crmUSoldDeb: null });

    //window.location.assign("/#/");
  };
}
